import GigCardCarousel from '@fiverr-private/gig_listings/src/entries/GigCardCarousel';
import withGigsComponentWrapper from '../GigsComponentsWrapper';

const GigCardCarouselWrapper = withGigsComponentWrapper(GigCardCarousel);

export default GigCardCarouselWrapper;
